import React from "react";

import TechnicalDescription from "pages/OpenProtocol/TechnicalDescription";
import ProductSampleType from "pages/OpenProtocol/ProductSampleType";
import RemainingBalance from "pages/OpenProtocol/RemainingBalance";
import OccurrenceDate from "pages/OpenProtocol/OccurrenceDate";
import OccurrenceType from "pages/OpenProtocol/OcurrenceType";
import SampleType from "pages/OpenProtocol/SampleType";

import { Visibility } from "components/Visibility";
import { Row } from "components/Layout/Grid";

import { TechnicalReportProps } from "./interface";
import { EnumCategories } from "models/Ticket";

export const TechnicalReport: React.FC<TechnicalReportProps> = (props) => {
  const {
    protocolCategory = "",
    occurrenceDate,
    setOccurrenceDate,
    uncontaminatedProductSampleType,
    setUncontaminatedProductSampleType,
    sampleType,
    setSampleType,
    remainingBalance,
    setRemainingBalance,
    qtdRemainingBalance,
    setQtdRemainingBalance,
    technicalDescription,
    setTechnicalDescription,
    othersOccurrence,
    setOthersOccurrence,
    occurrenceType,
    setOccurrenceType,
    isEditing
  } = props;

  const categoriesToDisplayFields: Array<string> = [
    EnumCategories.RECLAMACAO_TECNICA
  ];

  const visibleTechnicalReport: boolean = categoriesToDisplayFields.includes(protocolCategory);

  return (
    <Visibility visible={visibleTechnicalReport}>
      <OccurrenceType
        protocolCategory={protocolCategory}
        othersOccurrence={othersOccurrence}
        setOthersOccurrence={setOthersOccurrence}
        occurrenceType={occurrenceType}
        setOccurrenceType={setOccurrenceType}
        isEditing={isEditing}
      />

      <RemainingBalance
        protocolCategory={protocolCategory}
        remainingBalance={remainingBalance}
        setRemainingBalance={setRemainingBalance}
        qtdRemainingBalance={qtdRemainingBalance}
        setQtdRemainingBalance={setQtdRemainingBalance}
        isEditing={isEditing}
      />

      <TechnicalDescription
        protocolCategory={protocolCategory}
        technicalDescription={technicalDescription}
        setTechnicalDescription={setTechnicalDescription}
        isEditing={isEditing}
      />

      <OccurrenceDate
        protocolCategory={protocolCategory}
        occurrenceDate={occurrenceDate}
        setOccurrenceDate={setOccurrenceDate}
        isEditing={isEditing}
      />

      <Row className="align-center justify-between">
        <ProductSampleType
          protocolCategory={protocolCategory}
          uncontaminatedProductSampleType={uncontaminatedProductSampleType}
          setUncontaminatedProductSampleType={setUncontaminatedProductSampleType}
          isEditing={isEditing}
        />
        <SampleType
          protocolCategory={protocolCategory}
          sampleType={sampleType}
          setSampleType={setSampleType}
          isEditing={isEditing}
        />
      </Row>
    </Visibility>
  );
};
